import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import Link from "@components/Link";
import { PoweredBy } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import { FC } from "react";
export interface MinimalFooterProps {
  className?: string;
  isFullWidth?: boolean;
  isPartner?: boolean;
}
const MinimalFooter: FC<MinimalFooterProps> = t0 => {
  const $ = _c(26);
  const {
    className,
    isFullWidth,
    isPartner
  } = t0;
  const locale = useLanguage();
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex flex-col-reverse m:flex-row gap-2s py-3s items-center justify-between text-body-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("copyright", {
      year: new Date().getFullYear()
    });
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-opacity-50 text-neutral-675">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("imprint_href");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("imprint_label");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Link className="ml-2s underline text-opacity-50 text-neutral-675" href={t4}>{t5}</Link>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <span className="whitespace-nowrap">{t3}{t6}</span>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isPartner || $[17] !== locale) {
    t8 = isPartner && <PoweredBy locale={locale === "en" ? "en" : "de"} />;
    $[16] = isPartner;
    $[17] = locale;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className={t1}>{t7}{t8}</div>;
    $[19] = t1;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== isFullWidth || $[24] !== t9) {
    t10 = <Container fullWidth={isFullWidth} padding={true}>{t9}</Container>;
    $[23] = isFullWidth;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default MinimalFooter;